import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalShell from '../common/ModalShell';
import { buttonClasses } from '../common/tailwindClassnames';

type LeaveWorkspaceModalProps = {
  workspaceName: string;
  onConfirm: () => void;
  onCancel: () => void;
};

const LeaveWorkspaceModal = ({
  workspaceName,
  onConfirm,
  onCancel,
}: LeaveWorkspaceModalProps) => {
  const { t } = useTranslation();
  return (
    <ModalShell
      title={t('Leave Workspace?')}
      onClose={onCancel}
      footer={
        <>
          <button
            className={buttonClasses.destructive}
            type="button"
            data-testid="AccountPage-leaveWorkspaceConfirm-button"
            onClick={onConfirm}
          >
            {t('Leave Workspace')}
          </button>
          <button
            className={buttonClasses.cancel}
            type="button"
            data-testid="AccountPage-leaveWorkspaceCancel-button"
            onClick={onCancel}
          >
            {t('Cancel')}
          </button>
        </>
      }
    >
      <p className="text-ui-text-primary-text">
        {t(
          'Are you sure you want to leave {{workspaceName}}? If you decide to re-join, you will have to ask the administrator to add you again.',
          { workspaceName },
        )}
      </p>
    </ModalShell>
  );
};

export default LeaveWorkspaceModal;
